import { Reveal } from "@/components/Reveal";
import { IMAGES } from "@/lib/assets";
import { FlaskConical, Leaf } from "lucide-react";

export default function Duality() {
  return (
    <section className="bg-cream py-24 md:py-36" data-testid="duality">
      <div className="mx-auto max-w-[1500px] px-5 md:px-10">
        <Reveal className="max-w-2xl mb-16">
          <span className="font-sans uppercase tracking-[0.35em] text-[11px] text-amber-deep">The Philosophy</span>
          <h2 className="mt-5 font-serif text-4xl md:text-6xl leading-[0.95] text-obsidian">
            Two traditions,<br /><span className="italic">one formula.</span>
          </h2>
        </Reveal>

        <div className="grid md:grid-cols-2 border-t border-black/10">
          {/* Allopathy */}
          <Reveal className="group relative border-b md:border-r border-black/10 p-8 md:p-12">
            <div className="relative overflow-hidden aspect-[16/10] mb-8">
              <img src={IMAGES.clinical} alt="Clinical formulation" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
            </div>
            <div className="flex items-center gap-3 text-clinical">
              <FlaskConical className="w-5 h-5" strokeWidth={1.5} />
              <span className="font-sans uppercase tracking-[0.25em] text-[11px]">Allopathy</span>
            </div>
            <h3 className="mt-4 font-serif text-3xl md:text-4xl text-obsidian">Clinical Precision</h3>
            <p className="mt-4 font-sans font-light text-obsidian/70 leading-relaxed max-w-md">
              Proven molecules — Redensyl, AnaGain, Piroctone Olamine — dosed with
              pharmaceutical accuracy for measurable, visible outcomes.
            </p>
          </Reveal>

          {/* Ayurveda */}
          <Reveal delay={0.1} className="group relative border-b border-black/10 p-8 md:p-12">
            <div className="relative overflow-hidden aspect-[16/10] mb-8">
              <img src={IMAGES.herbal} alt="Ayurvedic herbs" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
            </div>
            <div className="flex items-center gap-3 text-amber-deep">
              <Leaf className="w-5 h-5" strokeWidth={1.5} />
              <span className="font-sans uppercase tracking-[0.25em] text-[11px]">Ayurveda</span>
            </div>
            <h3 className="mt-4 font-serif text-3xl md:text-4xl text-obsidian">Herbal Wisdom</h3>
            <p className="mt-4 font-sans font-light text-obsidian/70 leading-relaxed max-w-md">
              Argan oil, ginseng root and botanical extracts rooted in classical
              ritual — nourishing the scalp as a living, systemic ecosystem.
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
